import { Controller } from "@hotwired/stimulus";

// Moves a selection through the admin search's results with the arrow keys,
// and opens it with Enter, or in a new tab with ⌘/Ctrl+Enter. Focus stays in
// the search field, so typing keeps searching.
export default class extends Controller {
  static targets = ["result", "query"];

  next() {
    this.move(1);
  }

  previous() {
    this.move(-1);
  }

  open(event) {
    const selected = this.selected;
    if (!selected) return;

    event.preventDefault();
    if (event.metaKey || event.ctrlKey) {
      window.open(selected.href, "_blank");
    } else {
      selected.click();
    }
  }

  // The results are stale until the search catches up with what was typed, so
  // they're dimmed, and Enter searches instead of opening one of them.
  searching() {
    this.element.toggleAttribute("data-searching", true);
    this.select(null);
  }

  searched() {
    this.element.toggleAttribute("data-searching", false);
    this.select(this.resultTargets[0]);
  }

  // Typing then replaces the last search rather than adding to it.
  selectQuery() {
    this.queryTarget.select();
  }

  hover(event) {
    this.select(event.currentTarget);
  }

  move(step) {
    const results = this.resultTargets;
    if (results.length === 0) return;

    const index = Math.min(Math.max(results.indexOf(this.selected) + step, 0), results.length - 1);
    this.select(results[index]);
    results[index].scrollIntoView({ block: "nearest" });
  }

  select(selected) {
    this.resultTargets.forEach((result) =>
      result.toggleAttribute("data-selected", result === selected)
    );
  }

  get selected() {
    return this.resultTargets.find((result) => result.hasAttribute("data-selected"));
  }
}
